import { margin } from "@mui/system";
import React from "react";
import DotsComponent from "../../DotsComponent";

const RecruitmentId = ({data}) => {
  return (
    <>
      <div
        className="container"
        style={{ width: "30rem", margin: "0", marginRight: "1rem" }}
      >
      <DotsComponent/>
        <div
          style={{ textAlign: "center", padding: "10px", fontSize: "large" }}
        >
          <small className="camp-detail">Recruitment details</small>
        </div>
        <div className="sub-container">
          <div className="active">
          <div className="active-text"> In Progress</div>
          </div>

          <div className="allDetailsBox">
            <div>
              <div className="customername">
                <span>Employee Name: Mohit</span>
                <small style={{ fontSize: "12px" }}>
                  Joined On: 18th Aug 2022{" "}
                </small>
              </div>

              <div className="details">
                <span>
                  Interviewer: <b>Jon Aches</b>
                </span>
                <label>Email ID :jonach.123@gmail.com </label>
                <span>
                  {" "}
                  Contact details: <b>+91-7833516223</b>
                </span>
                <span>
                  {" "}
                  Department :<b>IT Dept.</b>
                </span>
                <span>
                  {" "}
                  Status: <b>Round 2</b>
                </span>
              </div>
            </div>

            <div className="image"></div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "0.5rem 5px 0 1rem",
              marginBottom:'20px'
            }}
          >
            <small>
              <b>Expencted Salary</b>
            </small>
            <span>
              <b>Rs.10,30,000.00</b>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default RecruitmentId;
